import React, { useEffect, useMemo } from 'react';

import { useLazyReadPaymentsQuery } from 'features/admin/features/payments/service/adminPaymentsApi';

import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { CommonTableProps } from '../../../../crm/interfaces/common.interface';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import {
    PaymentsFiltersProps,
    PaymentsProps,
} from '../service/payments.interface';
import { getColumns } from '../utils/getColumns';
import { Download, Type } from '../../../components/Download';
import UniversalTable from '../../../components/UniversalTable';

export const PaymentsContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        PaymentsFiltersProps,
        PaymentsProps
    >(useLazyReadPaymentsQuery, null);

    const tableProps = useMemo<
        CommonTableProps<PaymentsProps, PaymentsFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumns,
            entityName: 'Платежей',
            rowKey: item => item.order_id,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            get({ filters: filters }, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get]);
    return (
        <>
            <Download type={Type.payments} />
            <UniversalTable {...tableProps} />
        </>
    );
};
